import { createAction, props } from "@ngrx/store";
import { IEmployeeReport } from "src/app/shared/interfaces/employee-report/iemployeereport";

enum EmployeeReportActionType {
    LOAD_EMPLOYEE_REPORT = '[employee] load employee report from api',
    LOAD_EMPLOYEE_REPORT_SUCCESS = '[employee] load employee report from api return success'
}

const loadEmployeeReport = createAction(
    EmployeeReportActionType.LOAD_EMPLOYEE_REPORT
);

const loadEmployeeReportSuccess = createAction(
    EmployeeReportActionType.LOAD_EMPLOYEE_REPORT_SUCCESS,
    props<{ employee_report: IEmployeeReport }>()
);

export const EmployeeReportActions = {
    loadEmployeeReport,
    loadEmployeeReportSuccess
}